<form
  [formGroup]="passwordForm"
  (ngSubmit)="modifyPassword()"
>
  <div class="block-content-round">
    <p class="ion-grid-padding ion-margin-top-0">
      <strong>{{ account().firstName }} {{ account().lastName }}</strong>
      <span class="fs-xs ion-color-medium">({{ 'roles.' + account().role | translate }})</span>
    </p>

    <ion-grid class="ion-padding-horizontal-0">
      <ion-row>
        <ion-col>
          <h2 class="ion-margin-top-0">{{ 'account.old_passwaord' | translate }}</h2>
        </ion-col>
      </ion-row>

      <ion-row>
        <ion-col
          size="12"
          size-lg="6"
        >
          <ion-input
            formControlName="oldPassword"
            type="password"
            label="{{ 'account.old_passwaord' | translate }}"
            labelPlacement="floating"
            placeholder="{{ 'account.old_passwaord' | translate }}"
            fill="outline"
            mode="md"
            [clearOnEdit]="false"
            [helperText]="oldPasswordHelperText"
            [errorText]="oldPasswordErrorText"
          >
            <ion-input-password-toggle slot="end"></ion-input-password-toggle>
          </ion-input>
        </ion-col>
      </ion-row>

      <ion-row>
        <ion-col>
          <h2>{{ 'account.new_password' | translate }}</h2>
        </ion-col>
      </ion-row>

      <ion-row>
        <ion-col
          size="12"
          size-lg="6"
        >
          <ion-input
            formControlName="newPassword"
            type="password"
            label="{{ 'account.new_password' | translate }}"
            labelPlacement="floating"
            placeholder="{{ 'account.new_password' | translate }}"
            fill="outline"
            mode="md"
            [clearOnEdit]="false"
            [helperText]="newPasswordHelperText"
            [errorText]="newPasswordErrorText"
          >
            <ion-input-password-toggle slot="end"></ion-input-password-toggle>
          </ion-input>
        </ion-col>

        <ion-col
          size="12"
          size-lg="6"
        >
          <ion-input
            formControlName="newPasswordRepeat"
            type="password"
            label="{{ 'account.repeat_new_password' | translate }}"
            labelPlacement="floating"
            placeholder="{{ 'account.repeat_new_password' | translate }}"
            fill="outline"
            mode="md"
            [clearOnEdit]="false"
            [helperText]="newPasswordRepeatHelperText"
            [errorText]="newPasswordRepeatErrorText"
          >
            <ion-input-password-toggle slot="end"></ion-input-password-toggle>
          </ion-input>
        </ion-col>
      </ion-row>
    </ion-grid>

    @if (errorMessage()) {
      <div class="errors">
        {{ errorMessage() }}
      </div>
    }

    <div class="max-width-500">
      <ion-button
        expand="block"
        type="submit"
        fill="solid"
        [disabled]="isOffline()"
      >
        {{ 'general.save' | translate }}
      </ion-button>
    </div>
  </div>
</form>
